<template>
  <div>
    <h4 class="my-1">
      {{ report ? report.name : "Aguardando Relatório..." }}
      <b-button @click="fullscreen()">Tela Cheia</b-button>
    </h4>
    <div id="reportsContainer">
      <h5>Solicitando chave de acesso ao relatório...</h5>
      <b-spinner type="grow" label="Spinning"></b-spinner>
    </div>
  </div>
</template>

<script>
import * as pbi from "powerbi-client";

export default {
  name: "Report",
  props: {
    reportId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      powerbi: null,
      models: null,
      embedContainer: null
    };
  },
  computed: {
    report() {
      return this.$store.getters.getReports.find(
        report => report.reportId == this.reportId
      );
    },
    embedToken() {
      let token = this.$store.getters.getEmbedTokens.find(
        embedToken => embedToken.reportId == this.reportId
      );
      token = this.checkToken(token);
      return token;
    }
  },
  watch: {
    embedToken: function() {
      if (!this.embedToken) {
        return;
      }
      this.embedReport();
    }
  },
  mounted() {
    console.log("mounted");
    this.powerbi = new pbi.service.Service(
      pbi.factories.hpmFactory,
      pbi.factories.wpmpFactory,
      pbi.factories.routerFactory
    );
    this.models = pbi.models;
    this.embedContainer = document.getElementById("reportsContainer");
    if (!this.embedToken) {
      return;
    }
    this.embedReport();
  },
  methods: {
    embedReport() {
      var config = {
        type: "report",
        tokenType: this.models.TokenType.Embed,
        accessToken: this.embedToken.token,
        embedUrl: this.report.embedUrl,
        id: this.report.reportId,
        permissions: this.models.Permissions.All,
        settings: {
          filterPaneEnabled: false,
          navContentPaneEnabled: true
        }
      };
      this.powerbi.embed(this.embedContainer, config);
    },
    checkToken(token) {
      if (!this.report) {
        return null;
      }
      if (this.lastReportId != this.report.reportId) {
        this.lastReportId = this.report.reportId;
        if (!token) {
          this.$store.dispatch("retrieveEmbedToken", this.report);
          return null;
        }
      }
      return token;
    },
    fullscreen() {
      let report = this.powerbi.get(this.embedContainer);
      report.fullscreen();
    }
  }
};
</script>

<style>
h4 {
  text-align: center;
  margin-bottom: 10px;
}
#reportsContainer {
  width: 90%;
  height: calc(100vh - 8em);
  margin: 0 auto;
  text-align: center;
  vertical-align: middle;
}
#reportsContainer span {
  text-align: center;
  vertical-align: middle;
  margin-top: 20px;
}
#reportsContainer h5 {
  text-align: center;
  vertical-align: middle;
  margin-top: 100px;
}
</style>
